import React from "react";
import _ from "lodash";
import glamorous from "glamorous";
import { Popover, Checkbox } from "react-bootstrap";

import {
  getFilterWidget,
  setFilterValue
} from "../../vendor/signal-widgets/filterWidgets";
import "./location-type-selection-filter-widgets.css";
import { FlexColDiv } from "../../styles/container-elements";
import { getLadName, getLadLobLabel } from "../../components/lads";

const LocationTypeSelectionFilterWidget = (
  currentFilters,
  ladsGrouped,
  onChangeCallback
) => {
  const FilterCheckbox = lad => {
    const ladKey = getLadLobLabel(lad);
    const ladLabel = getLadName(lad);
    return (
      <Checkbox
        key={ladKey}
        name={ladKey}
        checked={ladKey && currentFilters.indexOf(ladKey.toLowerCase()) !== -1}
        onChange={e =>
          onChangeCallback(
            setFilterValue(currentFilters, ladKey, e.target.checked)
          )
        }
      >
        {ladLabel}
      </Checkbox>
    );
  };

  const boxesGrouped = _.mapValues(ladsGrouped, lad =>
    lad.map(l => FilterCheckbox(l))
  );
  const filterColumns = _.map(boxesGrouped, (boxes, groupName) => {
    return (
      <FlexColDiv key={groupName}>
        <h4>{groupName}</h4>
        {boxes}
      </FlexColDiv>
    );
  });
  const filterLayout = (
    <glamorous.Div
      display="flex"
      flexDirection="row"
      justifyContent="space-around"
    >
      {filterColumns}
    </glamorous.Div>
  );

  const popover = (
    <Popover
      id="popover-positioned-bottom"
      style={{
        minWidth: "600px"
      }}
    >
      <div className="filterBoxes">
        <Checkbox
          checked={currentFilters.length === 0}
          onChange={e =>
            onChangeCallback(
              setFilterValue(currentFilters, "all", e.target.checked)
            )
          }
        >
          <strong>Show All</strong>
        </Checkbox>
        <div className="divider" />
        <glamorous.Div
          display="flex"
          flexDirection="column"
          flexWrap="wrap"
          minHeight="10em"
          maxHeight="40em"
        >
          {filterLayout}
        </glamorous.Div>
      </div>
    </Popover>
  );

  return getFilterWidget(popover, onChangeCallback, currentFilters.length > 0);
};

export default LocationTypeSelectionFilterWidget;



// WEBPACK FOOTER //
// ./src/modules/locations/LocationTypeSelectionFilterWidget.js